import { useEffect, useState } from 'react';
import { useAuthContext } from '../../contexts/AuthProvider';
import useAppointmentActions from '../../hooks/APIHooks/appointments/useAppointmentActions';
import DashboardSectionLayout from '../../layouts/DashboardSectionLayout';
import { CalendarEvent } from '../../types/common';
import { convertAppointmentsToCalenderEvents } from '../../utils/commonFunctions';
import AcademiaCalendar from '../CommonComps/Calendars/AcademiaCalendar';
import IndicationBadge from '../CommonComps/IndicationBadge';

const AppointmentOverview = () => {
  // integration of react hooks here
  const [calendarData, setCalendarData] = useState<Array<CalendarEvent>>([]);

  // integration of context hooks here
  const { currentUser, currentUserType } = useAuthContext();

  // integration of custom API hooks here
  const {
    getAppointmentsByAssociateIdHandler,
    getAppointmentsByClientIdHandler,
  } = useAppointmentActions(
    '',
    currentUserType === 'user' ? currentUser?.id : undefined,
    currentUserType === 'client' ? currentUser?.id : undefined,
    'all'
  );

  console.log(
    'APPOINTMENT REQ LIST [ASSOCIATE]: ',
    getAppointmentsByAssociateIdHandler.data?.data,
    currentUserType
  );

  console.log(
    'APPOINTMENT REQ LIST [CLIENT]: ',
    getAppointmentsByClientIdHandler.data?.data
  );

  // refetching appointments to remove caching data here
  useEffect(() => {
    if (currentUserType === 'user') {
      getAppointmentsByAssociateIdHandler.refetch();
    } else {
      getAppointmentsByClientIdHandler.refetch();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // mapping appointment request for associates to get calendar event format here
  useEffect(() => {
    if (getAppointmentsByAssociateIdHandler.data?.data.length) {
      setCalendarData(
        convertAppointmentsToCalenderEvents(
          getAppointmentsByAssociateIdHandler.data.data,
          false
        )
      );
    }
  }, [getAppointmentsByAssociateIdHandler.data]);

  // mapping appointment request for clients to get calendar event format here
  useEffect(() => {
    if (getAppointmentsByClientIdHandler.data?.data.length) {
      setCalendarData(
        convertAppointmentsToCalenderEvents(
          getAppointmentsByClientIdHandler.data.data,
          true
        )
      );
    }
  }, [getAppointmentsByClientIdHandler.data]);

  // rendering appointment summary component here
  return (
    <DashboardSectionLayout sectionTitle='Appointment Overview'>
      <AcademiaCalendar
        events={calendarData}
        layoutId='appointment-calendar-underline'
      />

      <div className='mt-2 flex items-center justify-center md:justify-end gap-3'>
        <IndicationBadge indicationText='Pending' colorHex='#FF8042' />
        <IndicationBadge indicationText='Completed' colorHex='#388229' />
        <IndicationBadge indicationText='upcoming' colorHex='#845ADF' />
      </div>
    </DashboardSectionLayout>
  );
};

export default AppointmentOverview;
